import {
	PanelBar,
	PanelBarItem,
	PanelBarSelectEventArguments,
} from "@progress/kendo-react-layout";
import React, { FC } from "react";
import { ICON_NAMES } from "../../utils/constant";
import { logoutApi } from "api/auth";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { useAuthStore, useUserStore } from "store";
import { useMenuItemStore } from "store/menuItem";

enum Settings {
	Language = "English",
	Logout = "Logg out",
	User = "Min bruker",
}
const UserSetting: FC<{ onSelect: () => void }> = ({ onSelect }) => {
	const { t, i18n } = useTranslation();

	const { setLogout } = useAuthStore();
	const { resetStore } = useUserStore();
	// const { resetStore: resetOrgStore } = useUserOrganizationsStore();
	const { setMenuItem } = useMenuItemStore();

	const navigate = useNavigate();

	const logout = () => {
		setMenuItem([]);
		resetStore();
		// resetOrgStore();
		setLogout();
		logoutApi()
			.then(() => {
				navigate(`/login`);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const handleSelect = (e: PanelBarSelectEventArguments) => {
		const name = e.target.props.name;
		onSelect();
		if (name === Settings.Language) {
			//Todo: add switch language
			i18n.changeLanguage(i18n.language === "no" ? "en" : "no");
			window.location.reload();
		} else if (name === Settings.Logout) {
			logout();
		} else if (name === Settings.User) {
			navigate(`/profil`);
		}
	};
	return (
		<PanelBar
			style={{
				backgroundColor: "transparent",
				borderRadius: "12px",
				fontSize: "15px",
				width: "160px",
			}}
			onSelect={handleSelect}
			expandMode={"single"}
		>
			<PanelBarItem
				title={t("MyUser")}
				imageUrl={`/icon/${ICON_NAMES.UserAccount}.svg`}
				name={Settings.User}
			/>
			{/* <PanelBarItem
				title={"Innstillinger"}
				imageUrl={`/icon/${ICON_NAMES.SettingsGreen}.svg`}
			/> */}
			<PanelBarItem
				title={i18n.language === "no" ? t("English") : t("Norwegian")}
				imageUrl={`/icon/${ICON_NAMES.Language}.svg`}
				name={Settings.Language}
			/>
			<PanelBarItem
				title={t("Logout")}
				imageUrl={`/icon/logout.svg`}
				name={Settings.Logout}
			/>
		</PanelBar>
	);
};

export default UserSetting;
